import { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { useAuth } from "../context/AuthContext";

function EvidenceRedirect() {
  const { evidenceId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const navigate = useNavigate();
  const { user } = useAuth();

  const [evidence, setEvidence] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchEvidence = async () => {
      try {
        /* =========================
           1️⃣ Load Evidence
        ========================= */
        const evidenceRef = doc(db, "evidences", evidenceId);
        const evidenceSnap = await getDoc(evidenceRef);

        if (!evidenceSnap.exists()) {
          setError("Evidence not found.");
          return;
        }

        const evidenceData = evidenceSnap.data();

        /* =========================
           2️⃣ Logged-in Owner Access
        ========================= */
        if (user && evidenceData.userId === user.uid) {
          setEvidence(evidenceData);
          return;
        }

        /* =========================
           3️⃣ Public Share Access (TOKEN-BASED)
        ========================= */
        if (token) {
          const shareRef = doc(db, "publicProfileShares", token);
          const shareSnap = await getDoc(shareRef);

          if (!shareSnap.exists()) {
            setError("This public link is invalid.");
            return;
          }

          const shareData = shareSnap.data();

          if (shareData.revoked === true) {
            setError("This public link has been revoked.");
            return;
          }

          if (shareData.expiresAt?.toDate() < new Date()) {
            setError("This public link has expired.");
            return;
          }

          if (shareData.founderId !== evidenceData.userId) {
            setError("You do not have access to this evidence.");
            return;
          }

          setEvidence(evidenceData);
          return;
        }

        /* =========================
           4️⃣ No Access
        ========================= */
        setError("You do not have access to this evidence.");
      } catch (err) {
        setError("Failed to load evidence.");
      }
    };

    fetchEvidence();
  }, [evidenceId, user, token]);

  /* =========================
     ERROR STATE
  ========================= */
  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <p>{error}</p>
        <button onClick={() => navigate(-1)}>Go back</button>
      </div>
    );
  }

  /* =========================
     LOADING STATE
  ========================= */
  if (!evidence) {
    return <p style={{ padding: 24 }}>Opening evidence…</p>;
  }

  /* =========================
     LINK → REDIRECT
  ========================= */
  if (evidence.type === "link") {
    window.location.href = evidence.url;
    return null;
  }

  /* =========================
     FILE → EMBED PREVIEW
  ========================= */
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src={evidence.fileUrl}
        title="Evidence Preview"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
}

export default EvidenceRedirect;
